<template>
  <div
    class="page main_container"
  >
    <div
      class="grow"
    />

    <Icon
      width="232"
      height="232"
      :icon="require(`@/assets/images/404.png`)"
    />

    <typography
      variant="subtitle"
      style="margin-bottom: 8px; margin-top: 32px"
    >
      Такой страницы нет
    </typography>

    <typography
      variant="body1"
      center
    >
      Её удалили или перенесли. Вернись на главную или обратись в службу поддержки, если есть вопрос
    </typography>

    <div
      class="grow"
    />

    <AppButton
      full-width
      style="margin-top: 24px"
      @click="home"
    >
      Перейти на главную
    </AppButton>
  </div>
</template>

<script setup>
import Icon from '@/components/UI/Icon.vue'
import AppButton from '@/components/UI/AppButton.vue'
import Typography from '@/components/UI/Typography.vue'
import {indexedStore} from "@/indexedDB/indexedStore.js"
import { product } from '@product/product.js'

async function home() {
  await indexedStore.clear()
  if (product.desktopRoutes.length && location.href.includes('/desktop')) {
    location.href = '/desktop'
  } else {
    location.href = '/'
  }
}

</script>

<style lang="scss" scoped>
.page {
  min-height: 100svh;
  max-height: 100svh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  padding: 36px;
}

.grow {
  flex-grow: 1;
}
</style>
